export { UdiSoftwareLabel } from './UdiSoftwareLabel';
